<template>
  <div class="shijian-wrapper" :style="{width:width*0.29+'px'}">
    <div class="shijian-head">事件办理</div>
    <div id="chart_example">
    </div>
  </div>
</template>

<script>
  var shijianChart,
    that
  import echarts from 'echarts'

  export default {
    props: {
      height: null,
      width: null,
      shijianEc: null
    },
    data() {
      return {}
    },
    watch: {
      shijianEc(newValue, oldValue) {
        this.initShijianEc(newValue)
      }
    },
    computed:{
      no125 () {
        return this.height/0.302>750 || this.width > 1550?true:false
      },
    },
    methods: {
      initShijianEc(ec) {
        shijianChart = echarts.init(document.getElementById('chart_example'));
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ec.legend,
            top: 10,
            textStyle:{    //图例文字的样式
              color:'#3c3c3c',  //文字颜色
              fontSize:16
            },
          },
          grid: {
            show: false,
            x: 30,
            y: 40,
            y2: 30,
            x2: 30
          },
          dataZoom: {
            type: 'inside',
            startValue: 0,
            endValue: 8,
          },
          xAxis: [
            {
              type: 'category',
              splitLine: {
                show: false
              },
              data: ec.xaxis,
              axisTick: {
                alignWithLabel: false
              },
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitLine: {
                show: false
              }
            }
          ],
          series: ec.series.map(item => {
            return {
              name: item.name,
              type: 'bar',
              barGap: 0,
              data: item.data,
              barWidth: 15,
              itemStyle: {
                color: item.color,
                barBorderRadius: 5
              },
            }
          })
        }
        if (!this.no125) {
          option.legend.itemHeight = 10
          option.legend.itemWidth = 15
          option.dataZoom = {
            type: 'inside',
            startValue: 0,
            endValue: 5,
          }
        }
        shijianChart.setOption(option);
        window.addEventListener('resize', this.resizeEc);
        //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
        // window.addEventListener('resize', function () {
        //   myChart.resize()
        // });
      },
      resizeEc () {
        shijianChart.resize()
        shijianChart.clear()
        this.initShijianEc(this.shijianEc)
      }
    },
    mounted() {
      that = this
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeEc)

    }
  }
</script>

<style scoped>
  .shijian-wrapper {
    /*width:575px;*/
    background: #fff;
    border: 1px solid #fff;
    border-radius: 5px;
    padding-top: 20px;
    color: #444;
  }

  #chart_example {
    /*width: 575px;*/
    /*height: 260px;*/
    width: 100%;
    height: 92%;
    margin: 0 auto;
  }

  .shijian-head {
    height: 20px;
    line-height: 20px;
    border-left: 3px solid #d22b2b;
    padding-left: 10px;
    font-size: 16px;
  }

</style>
